import { TableRow, TableCell } from '@mui/material';
import TreeTableCellContent from './TreeTableCellContent';

const collapsedCellStyle = {
  py: 0,
  height: 0,
  overflow: 'hidden',
  borderBottom: 'none',
  transition: 'all 0.2s ease-out',
  '& > *': {
    opacity: 0,
    transform: 'translateY(-8px)',
    transition: 'all 0.2s ease-out',
  },
};

const expandedCellStyle = {
  transition: 'all 0.2s ease-out',
  '& > *': {
    opacity: 1,
    transform: 'translateY(0)',
    transition: 'all 0.2s ease-out',
  },
};

const TreeTableRow = ({
  node,
  depth,
  hasChildren,
  isExpanded,
  isVisible,
  columns,
  onRowClick,
  onToggleExpand,
  renderActions,
}) => {
  const handleClick = () => {
    if (onRowClick) {
      onRowClick(node);
    }
  };

  return (
    <TableRow
      hover={isVisible && !!onRowClick}
      onClick={isVisible ? handleClick : undefined}
      sx={{
        cursor: isVisible && onRowClick ? 'pointer' : 'default',
        visibility: isVisible ? 'visible' : 'collapse',
      }}>
      {columns.map((column, index) => (
        <TableCell
          key={column.key}
          align={column.align || 'left'}
          sx={isVisible ? expandedCellStyle : collapsedCellStyle}>
          <TreeTableCellContent
            column={column}
            node={node}
            index={index}
            depth={depth}
            hasChildren={hasChildren}
            isExpanded={isExpanded}
            onToggleExpand={onToggleExpand}
            renderActions={renderActions}
          />
        </TableCell>
      ))}
    </TableRow>
  );
};

export default TreeTableRow;
